import React from 'react';
import {createRoot} from 'react-dom/client';

import JshModule from '@core/scripts/helper/jsh-module';
import Wishlist from '@wishlist/components/Wishlist.tsx';
import {loadDataFromModuleScope} from '@checkout/components/module-scope-loader.js';

const {moduleScope} = JshModule('wishlist/wishlist');
const model = loadDataFromModuleScope(moduleScope, 'jsh-model');

const {
    device,
    hasEmbeddedSwiper,
    initialWishlistItems,
    initialWishlistSortOption,
    isWishlistEmpty,
    pageType,
    pageViewId,
    pointOfSaleId,
    sliderType,
    swiperDataUrl,
    swiperParamsString,
    texts,
    wishlistCount,
    userIsLoggedIn,
} = model;

createRoot(moduleScope).render(
    <Wishlist
        device={device}
        hasEmbeddedSwiper={hasEmbeddedSwiper}
        initialWishlistItems={initialWishlistItems}
        initialWishlistSortOption={initialWishlistSortOption}
        isWishlistEmpty={isWishlistEmpty}
        pageType={pageType}
        pageViewId={pageViewId}
        pointOfSaleId={pointOfSaleId}
        sliderType={sliderType}
        swiperDataUrl={swiperDataUrl}
        swiperParamsString={swiperParamsString}
        texts={texts}
        userIsLoggedIn={userIsLoggedIn}
        wishlistCount={wishlistCount}
    />
);